import * as React from 'react';
import * as style from './FixedBlock.css';

export interface IFixedBlockProps extends React.PropsWithChildren {
  top?: number | string;
  bottom?: number | string;
  left?: number | string;
  right?: number | string;
}

export const FixedBlock = (props: IFixedBlockProps) => {
  const { children, top = 0, bottom = 'auto', left = 0, right = 'auto' } = props;

  return (
    <div
      style={{
        top,
        bottom,
        left,
        right,
      }}
      className={style['layout']}
    >
      {children}
    </div>
  );
};
